module.exports = "/assets/5d676e6728816da223f6b677c965f282.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UG.png
// module id = 1890
// module chunks = 0